function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "teal",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M16.071 17.485L.515 1.93C.09 1.505.09.939.515.515c.424-.425.99-.425 1.414 0L17.485 16.07c.425.424.425.99 0 1.414-.424.425-.99.425-1.414 0z"
}), React.createElement("path", {
  d: "M1.929 17.485L17.485 1.93c.425-.424.425-.99 0-1.414-.424-.425-.99-.425-1.414 0L.515 16.07c-.425.424-.425.99 0 1.414.424.425.99.425 1.414 0z"
}));

var SvgCloseBtn = function SvgCloseBtn(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0idGVhbCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTYuMDcxIDE3LjQ4NUwuNTE1IDEuOTNDLjA5IDEuNTA1LjA5LjkzOS41MTUuNTE1Yy40MjQtLjQyNS45OS0uNDI1IDEuNDE0IDBMMTcuNDg1IDE2LjA3Yy40MjUuNDI0LjQyNS45OSAwIDEuNDE0LS40MjQuNDI1LS45OS40MjUtMS40MTQgMHoiLz48cGF0aCBkPSJNMS45MjkgMTcuNDg1TDE3LjQ4NSAxLjkzYy40MjUtLjQyNC40MjUtLjk5IDAtMS40MTQtLjQyNC0uNDI1LS45OS0uNDI1LTEuNDE0IDBMLjUxNSAxNi4wN2MtLjQyNS40MjQtLjQyNS45OSAwIDEuNDE0LjQyNC40MjUuOTkuNDI1IDEuNDE0IDB6Ii8+PC9nPjwvc3ZnPg==";
export { SvgCloseBtn as ReactComponent };